import { NgModule } from '@angular/core';
import { SmsService } from './services/sms.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    imports: [HttpClientModule],
    providers: [SmsService]
})
export class DomainSMSModule {}